import { useEffect, useState } from 'react'

export const useInitUtmSource = () => {
  const [utmSource, setUtmSource] = useState(false)

  useEffect(() => {
    if (window.location.search.includes('utm_source=MM')) {
      setUtmSource(true)
      sessionStorage.setItem('utmSource', 'true')
    } else {
      const isUtmSourceMMFromStorage = sessionStorage.getItem('utmSource')

      if (isUtmSourceMMFromStorage) {
        setUtmSource(isUtmSourceMMFromStorage === 'true')
      }
    }
  }, [])

  return { utmSource, setUtmSource }
}
